import Swal from "sweetalert2";

export const addToCartAlert = () => {
    Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Added to cart",
        showConfirmButton: false,
        timer: 1200,
        background: "#ffffffff",
        color: "#06682dff",
        iconColor: "#06682dff",
    });
};
